module.exports = __webpack_public_path__ + "static/media/banner1.afe92589.jpg";